import { VotingConstants } from "../../constants/voting.constants";

const initialState = {
	votingsList: [],
	voting: null,
	itemLoading: false,
	listLoading: false,
	addresses: {
		addresses: [],
		loading: true,
	},
	addressesModal: {
		opened: false,
		showContent: [],
		showEntity: "",
	},
	editingVoting: false,
	results: {
		loading: true,
		results: [],
		otherResults: [],
	},
};

export default (state = initialState, action) => {
	switch (action.type) {
		case VotingConstants.GET_ALL_VOTING:
			return {
				...state,
				listLoading: true,
			};
		case VotingConstants.GET_ALL_VOTING_SUCCESS:
			return {
				...state,
				listLoading: false,
				votingsList: action.payload,
			};
		case VotingConstants.GET_ONE_VOTING:
			return {
				...state,
				itemLoading: true,
			};
		case VotingConstants.GET_ONE_VOTING_SUCCESS:
			return {
				...state,
				itemLoading: false,
				voting: action.payload,
				votingsList: action.payload
					? state.votingsList.map((voting) => {
							if (voting.id === action.payload.id) {
								return action.payload;
							} else return voting;
					  })
					: state.votingsList,
			};

		case VotingConstants.LOADING_ADDRESSES:
			return {
				...state,
				addresses: {
					addresses: [],
					loading: true,
				},
			};
		case VotingConstants.GET_ADDRESSES_BY_COMPANY:
			return {
				...state,
				addresses: {
					addresses: action.payload,
					loading: false,
				},
			};
		case VotingConstants.CONTROL_MODAL:
			return {
				...state,
				addressesModal: {
					opened: action.payload.opened,
					showContent: action.payload.showContent,
					showEntity: action.payload.showEntity,
				},
			};
		case VotingConstants.GET_VOTING_RESULTS:
			return {
				...state,
				results: {
					loading: true,
				},
			};
		case VotingConstants.GET_VOTING_RESULTS_SUCCESS:
			return {
				...state,
				results: {
					loading: false,
					results: action.payload,
				},
			};
		case VotingConstants.GET_VOTING_OTHER_RESULTS:
			return {
				...state,
				results: {
					...state.results,
					loading: true,
				},
			};
		case VotingConstants.GET_VOTING_OTHER_RESULTS_SUCCESS:
			return {
				...state,
				results: {
					...state.results,
					loading: false,
					otherResults: action.payload,
				},
			};
		case VotingConstants.VOTING_DELETING:
			return {
				...state,
				itemLoading: true,
				listLoading: true,
			};
		case VotingConstants.VOTING_DELETED:
			return {
				...state,
				voting: null,
				itemLoading: false,
				listLoading: false,
			};
		case VotingConstants.ITEM_LOADING:
			return {
				...state,
				itemLoading: true,
			};
		case VotingConstants.ITEM_LOADED:
			return {
				...state,
				itemLoading: false,
			};
		default:
			return state;
	}
};
